import { type QueryFunctionContext } from '@tanstack/react-query'
import { apiGet } from '@/features/shared/utils/dataFetching'
import { type CheckUserEmailResponse, type User } from '@/features/account/services/User/types'
import { mapGqlUserToUser } from '@/features/account/services/User/utils'
import { logInfo } from '@/features/shared/utils/logger'
import { isOnServer } from '@shared/constants/util'
import { fetchGraphql } from '@/features/shared/utils/dataFetching/reactQuery/graphql'
import { BaseUserDocument, UserProfileDocument } from '@/gql/graphql'
import { type UserProfileQueryKey } from '@/features/account/services/User/queries'

export const fetchUser = async (context: QueryFunctionContext): Promise<User> => {
  const data = await fetchGraphql(BaseUserDocument, undefined, {
    // only throw if data is null. This is meant to make this query more resilient
    // to partial failures
    throwOnGqlError: false,
    suppressIdHeaders: true,
    context,
  })

  if (!data.customer) {
    if (!isOnServer()) {
      logInfo('Debug: no customer found error', { data })
    }
    throw new Error('customer is not found')
  }

  return mapGqlUserToUser(data.customer)
}

export const fetchUserProfile = (context: QueryFunctionContext<UserProfileQueryKey>) => {
  const [, userId] = context.queryKey
  return fetchGraphql(UserProfileDocument, { customerId: String(userId) }, { context })
}

export const checkUserEmail = (email: string) => {
  return apiGet<CheckUserEmailResponse>({
    config: {
      url: 'api/v1/customers/check.json',
      params: { email },
    },
    fetcherName: 'checkUserEmail',
  })
}
